import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

export class EirApp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            callOuts: []
        }
        // this.callOutsLength();
    }

    componentDidMount() {
        this.callOutsLength()
    }    

    callOutsLength = () => {
        var callouts = [];
        if(this.props.height == "75%" && this.props.graphic.length > 2) {
            for ( let i = 0; i < 3; i++ ) {
                    callouts[i] = this.props.graphic[i];
            }
            this.setState({callOuts : callouts });
        }
        else {
            this.setState({
                callOuts: this.props.graphic
            });
        }
    }
    
    appHeight = () => {            
        if (this.props.height == "75%") {
            return 'eir-aspectratio-10-16 eir-aspectratio-md-15-6';
        }
        
        return 'eir-aspectratio-10-16 eir-aspectratio-md-15-8';
    }
    render() {
        return (
            <div className={'eir-app-container-main eir-aspectratio eir-fullwidth-banner ' + (this.appHeight())}>
                <img className="img-fluid position-absolute w-100 d-none d-md-block" 
                    src={this.props.image.path}
                    alt={this.props.image.description} />
                <img className="img-fluid-mob position-absolute w-100 d-md-none" 
                    src={this.props.imageMobile.path}
                    alt={this.props.imageMobile.description} />
                <div className={' eir-leftRight mb-6 mt-6 container-fluid ' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default') }>
                    <div className={'row ' + (this.props.alignment == 'right' ? 'justify-content-end' : 'justify-content-start')}>
                        <div className={'col-12 col-md-6 d-flex align-items-center justify-content-center eir-minh-38 col ' + (this.props.alignment == 'left' ? 'order-md-3': 'order-md-1')}>
                        </div>
                        <div className="eir-minh-38 col-12 col-md-6 d-flex align-items-center justify-content-center flex-column text-center text-md-left order-2  eir-minh-50 col">
                            <div className="eir-fluid-md-w50 eir-fluid-xl-w50">
                                <h2 className={`eir-app-title eir-title display-4 eir-display-sm-3 eir-display-xl-2 w-100`}>
                                    {this.props.title}
                                </h2>
                                <div className="eir-app-callouts">
                                {Object.values(this.state.callOuts).map((item, index) => {
                                    return (
                                        <div>                
                                        <Row className="graphic">
                                            <Col className="col-1">
                                                    <img key={index} src={item.image.path} alt={item.image.description} />
                                            </Col>
                                            <Col className="eir-text w-100">
                                                <p>{item.linkText}</p>
                                            </Col> 
                                         </Row>
                                        </div>                       
                                    )
                                })}
                                </div>
                                <div className="app-logo">
                                    {this.props.button && 
                                    this.props.button.map((item,index) => {
                                        return (
                                            <a 
                                                target="_blank" rel="noopener noreferrer" 
                                                href={item.linkURI}>
                                                <img 
                                                    key={index} 
                                                    src={item.Image.path} 
                                                    alt={item.Image.description}
                                                    title={item.linkText}
                                                />
                                            </a>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          );
        }
}

export default EirApp
